import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type NoticeTone = 'info' | 'success' | 'warning' | 'error' | 'neutral';

const tones: Record<NoticeTone, string> = {
  info: 'border-info/30 bg-info/10',
  success: 'border-success/30 bg-success/10',
  warning: 'border-warning/30 bg-warning/10',
  error: 'border-error/30 bg-error/10',
  neutral: 'border-border bg-surface',
};

/** An inline message on the page: errors, warnings and short explanations. Text stays in the foreground colour. */
export function Notice({ tone = 'info', title, children, icon, action, className, role }: {
  tone?: NoticeTone; title?: ReactNode; children?: ReactNode; icon?: ReactNode; action?: ReactNode; className?: string; role?: string;
}) {
  return (
    <div role={role ?? (tone === 'error' ? 'alert' : undefined)} className={cn('flex items-start gap-3 rounded-2xl border px-4 py-3 text-sm text-foreground', tones[tone], className)}>
      {icon && <span className="mt-0.5 shrink-0 [&_svg]:h-4 [&_svg]:w-4">{icon}</span>}
      <div className="min-w-0 flex-1">
        {title && <p className="font-medium">{title}</p>}
        {children && <div className={cn(title && 'mt-0.5', 'text-foreground/85')}>{children}</div>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}
